
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${isScrolled ? 'bg-white shadow-lg' : 'bg-white/90 backdrop-blur-sm'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/361aa2128fb228dd2a394b19ce909129/5373f965471507d5f638f61e11be7bf8.jpeg" 
              alt="Venezia Agency Logo" 
              className="h-12 w-auto object-contain"
            />
          </div>

          <div className="hidden lg:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')} className="text-sm font-medium text-[#0F0F0F] hover:text-[#C77A5A] transition-colors duration-300 relative group whitespace-nowrap cursor-pointer">
              Home
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#C77A5A] group-hover:w-full transition-all duration-300"></span>
            </button>
            <button onClick={() => scrollToSection('about')} className="text-sm font-medium text-[#0F0F0F] hover:text-[#C77A5A] transition-colors duration-300 relative group whitespace-nowrap cursor-pointer">
              About Us
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#C77A5A] group-hover:w-full transition-all duration-300"></span>
            </button>
            <button onClick={() => scrollToSection('methodology')} className="text-sm font-medium text-[#0F0F0F] hover:text-[#C77A5A] transition-colors duration-300 relative group whitespace-nowrap cursor-pointer">
              Methodology
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#C77A5A] group-hover:w-full transition-all duration-300"></span>
            </button>
            <button onClick={() => scrollToSection('offers')} className="text-sm font-medium text-[#0F0F0F] hover:text-[#C77A5A] transition-colors duration-300 relative group whitespace-nowrap cursor-pointer">
              Offers
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#C77A5A] group-hover:w-full transition-all duration-300"></span>
            </button>
            <button onClick={() => scrollToSection('questions')} className="text-sm font-medium text-[#0F0F0F] hover:text-[#C77A5A] transition-colors duration-300 relative group whitespace-nowrap cursor-pointer">
              FAQ
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#C77A5A] group-hover:w-full transition-all duration-300"></span>
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-sm font-medium text-[#0F0F0F] hover:text-[#C77A5A] transition-colors duration-300 relative group whitespace-nowrap cursor-pointer">
              Contact
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#C77A5A] group-hover:w-full transition-all duration-300"></span>
            </button>
          </div>

          <div className="hidden lg:block">
            <button onClick={() => scrollToSection('free-advice')} className="px-6 py-2.5 bg-[#F2A35E] text-white text-sm font-semibold rounded-lg shadow-md hover:shadow-lg hover:bg-[#C77A5A] transition-all duration-300 whitespace-nowrap cursor-pointer">
              Free Consultation
            </button>
          </div>

          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-[#0F0F0F] cursor-pointer"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-gradient-to-b from-[#F6C1A1] to-white border-t border-[#F6C1A1]">
          <div className="px-6 py-4 space-y-4">
            <button onClick={() => scrollToSection('home')} className="block w-full text-left text-sm font-medium text-[#0F0F0F] hover:text-[#C77A5A] transition-colors duration-300 py-2 cursor-pointer">
              Home
            </button>
            <button onClick={() => scrollToSection('about')} className="block w-full text-left text-sm font-medium text-[#0F0F0F] hover:text-[#C77A5A] transition-colors duration-300 py-2 cursor-pointer">
              About Us
            </button>
            <button onClick={() => scrollToSection('methodology')} className="block w-full text-left text-sm font-medium text-[#0F0F0F] hover:text-[#C77A5A] transition-colors duration-300 py-2 cursor-pointer">
              Methodology
            </button>
            <button onClick={() => scrollToSection('offers')} className="block w-full text-left text-sm font-medium text-[#0F0F0F] hover:text-[#C77A5A] transition-colors duration-300 py-2 cursor-pointer">
              Offers
            </button>
            <button onClick={() => scrollToSection('questions')} className="block w-full text-left text-sm font-medium text-[#0F0F0F] hover:text-[#C77A5A] transition-colors duration-300 py-2 cursor-pointer">
              FAQ
            </button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left text-sm font-medium text-[#0F0F0F] hover:text-[#C77A5A] transition-colors duration-300 py-2 cursor-pointer">
              Contact
            </button>
            <button onClick={() => scrollToSection('free-advice')} className="block w-full px-6 py-2.5 bg-[#F2A35E] text-white text-sm font-semibold rounded-lg shadow-md hover:shadow-lg hover:bg-[#C77A5A] transition-all duration-300 mt-4 cursor-pointer">
              Free Consultation
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
